import { toggle } from "./toggle";

type Inputs = {
  toggleElement: HTMLElement;
  menuElement: HTMLElement;
};

export function initMobileMenu({ toggleElement, menuElement }: Inputs): void {
  toggleElement.addEventListener("click", () => toggle(menuElement));

  document.addEventListener("click", (e) => {
    const target = e.target as Node;
    if (!toggleElement.contains(target) && !menuElement.contains(target)) {
      menuElement.classList.add("hidden");
    }
  });

  menuElement.addEventListener("click", (e) => {
    if ((e.target as HTMLElement).closest("a")) {
      menuElement.classList.add("hidden");
    }
  });
}
